import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { duplicateFolderInStorage } from "@/services/supabase/storage/actions/dupplicateFolderInStorage";

export const duplicatePromptbook = async (promptbookId: string, teamId?: string) => {
  const ownerId = teamId || (await getUserId());

  if (!ownerId) return { error: new Error("no owner"), newPromptbookId: null };

  const { data: newPromptbookId, error } = await supabase.rpc("duplicate_promptbook", {
    original_resource_id: promptbookId,
    owner_id: ownerId,
  });

  if (newPromptbookId) {
    await duplicateFolderInStorage("promptbooks", `${promptbookId}/files`, "promptbooks", `${newPromptbookId}/files`);
  }

  return { newPromptbookId, error };
};
